import React from 'react';
// import ReactDOM from 'react-dom';
import moment from 'moment';
import chatService from '../../services/chatService';

//Context
import {AppContext} from '../../AppModule/Context';
import {withExpertHomeContext} from '../../screens/ExpertHome/ExpertHomeContextProvider';

//Constants
import VIDABOO_CONSTANTS from '../../config/consts';

//Services
import {
  ListeningRoomService,
  PrivateRoomService,
  WSService,
} from '../../services/websocketService';
import storageService from '../../services/storageService';
import VisibilityHandlerService from '../../services/visibilityHandlerService';
import AnalyticsService from '../../services/analyticsService';

import audioSelected from '../../assets/audio/040458664-positive-multimedia-ding-2-mal.mp3';
import audioFileService from '../../services/audioFileService';
import utilsService from '../../services/utilsService';
import ChatBoxRender from './chatBoxRender';
import {withChatbotContext} from '../expertDashboardModule/expertSettingsComponent/chatbotContextProvider';
import {withWidgetContext} from '../widgetComponent/widgetContextProvider';
import chatBridgeService from '../../services/chatBridgeService';
// import marketingParametersService from '../../services/restServices/marketingParametersService';
import UpdateMarketingParamsComponent from '../common/updateMarketingParamsComponent/updateMarketingParamsComponent';
import expertHomeService from '../../services/expertHomeService';
import aiCompletionService from '../../services/restServices/aiCompletionService';
// import ChatBoxPrivateRoomTest from './chatBoxPrivateRoomTest';

let PAGE_SIZE = 40;
class ChatBox extends React.Component {
  constructor(props) {
    super(props);
    // refs
    this.siteGuestId = utilsService.getFormattedId(
      VIDABOO_CONSTANTS.ID_PREFIX.SITE_GUEST,
      [
        props.peerUserId,
        props.chatRoomDto.ownerObjectType,
        props.chatRoomDto.ownerObjectId,
      ],
    );
    this.myUserId = props.currentUser.userId;
    this.myParticipantType = props.isMentor
      ? VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.MENTOR
      : VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.GUEST;
    this.myParticipantId = this.getParticipantId();

    this.messagesHistory = [];
    this.peerName = props.peerName;
    this.isMentor = props.isMentor;
    this.peerIsTypingTimeoutPromises = {};

    // state
    this.state = {
      audioPaused: true,
      maxChatBox: 3, //TODO:should be in const file.
      chatInitialized: false,
      firstMessagesPushed: false,
      failRespone: false,
      chatBoxMessages: [],
      unreadMessagesByCurrentUser: [],
      sentReadMessages: {},
      messageCounter: 0,
      showChatTitle: true,
      showMessages: false,
      needToReset: true,
      expended: true,
      peerDidNotRespond: true,
      peerIsTyping: false,
      leadCollectorPopup: false,
      messageToSend: '',
      peerNameFocused: false,
      currentPage: 0,
      showLoadMore: '',
      allChatMessages: [],
      messageToBeSendQueue: [], // it is if chatRoomid is not available then send on available
      chatMarketingParams: false,
      nonRespondedMessageSent: false,
      scrollHeight: 0,
      scrollPosition: 0,
      chatboxHeight: 0,
      showNewMsgPopup: false,
      isWsConnected: WSService.socketEstablished() === true,
      typingParticipantsInfoObj: {},
    };
    this.peerNameRef = React.createRef();
    this.chatTextAreaRef = React.createRef();
  }
  componentDidMount() {
    this.addScrollMonitor();
    this.props.onRef(this);
    if (!this.props.isDemo) {
      this.initChatBox(this.props);
      this.handleWindowResize();
      this.registerWindowResize();
      this.expandChatBox();
      if (this.props.isMentor) {
        //This is supposed to connect only incase of mentor
        this.subscribeToChatBridgeService();
        this.deleteConnectToPrivateRoom =
          PrivateRoomService.connectToPrivateRoom(
            this.props.chatRoomDto.roomId,
            this.props.currentUser.userId,
          );
      }
      this.deleteDoWhenMessageReceivedFromPrivateRoom =
        PrivateRoomService.doWhenMessageReceivedFromPrivateRoom(
          this.props.chatRoomDto.roomId,
          this.doWhenMessageReceivedFromPrivateRoom,
        );
      this.handleWebsocketStatusChanges();
    } else {
      this.updateDemoChatMessages();
      this.deleteDoWhenMessageReceivedFromListeningRoom =
        ListeningRoomService.doWhenMessageReceivedFromListeningRoom((data) => {
          if (
            data.messageType ===
            VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.AI_COMPLETION_UPDATE
          ) {
            if (
              data.content.SubType ===
              VIDABOO_CONSTANTS.AI_COMPLETION_UPDATE_SUBTYPES.DEMO_COMPLETION
            ) {
              this.doWhenOoniAiDemoResponseReceived(data.content.response);
            }
          }
        });
    }
  }

  componentDidUpdate = (prevProps) => {
    //if any new customer has joined, then users gets updated in expertHomeContext.privateChatRoomDto, so need to update the chatRoom name (peerName) accordingly
    if (
      this.props.expertHomeContext?.privateChatRoomDto?.roomId &&
      this.props.expertHomeContext.privateChatRoomDto.participants !==
        prevProps.expertHomeContext?.privateChatRoomDto?.participants &&
      !this.props.chatRoomDto.roomInfoDto?.roomName
    ) {
      this.updatePrivateChatRoomName();
    }
    //this code updates the roomName and participant names info whenever it's changed in peerAdditionalInfo
    if (prevProps.updatedChatRoomDto !== this.props.updatedChatRoomDto) {
      this.setRoomAndParticipantNamesFromChatRoom(this.props.chatRoomDto);
    }
    if (this.props.isDemo) {
      if (
        prevProps.mentor.mentorDto.appControlDto.automaticChatMessage !==
        this.props.mentor.mentorDto.appControlDto.automaticChatMessage
      ) {
        this.updateDemoChatMessages();
      } else if (
        prevProps.mentor.mentorDto.mentorId !==
        this.props.mentor.mentorDto.mentorId
      ) {
        this.resetDemoChatMessages();
      }
    }
  };

  componentWillUnmount = () => {
    if (utilsService.getIsInExpertHome()) {
      this.unSubscribeToChatBridgeService();
    }

    if (!this.props.isDemo) {
      // this.connectToPeerShoutingRoomDeleteFunction();
      this.deleteDoWhenVisibilityChangeListener();
    }
    this.waitForPeerResponseTimeout &&
      clearTimeout(this.waitForPeerResponseTimeout);

    this.scrollSetTimeout && clearTimeout(this.scrollSetTimeout);
    Object.values(this.peerIsTypingTimeoutPromises ?? {}).forEach(
      (peerIsTypingTimeoutPromiseId) =>
        clearTimeout(peerIsTypingTimeoutPromiseId),
    );
    if (!VIDABOO_CONSTANTS.NATIVE_APP) {
      document.removeEventListener(
        'mousedown',
        this.handleClickForEmojiOnBlur,
        false,
      );
      window.removeEventListener('resize', this.handleWindowResize);
    }
    this.deleteConnectToPrivateRoom && this.deleteConnectToPrivateRoom();
    this.deleteDoWhenMessageReceivedFromPrivateRoom &&
      this.deleteDoWhenMessageReceivedFromPrivateRoom();
    this.deleteDoWhenMessageReceivedFromListeningRoom &&
      this.deleteDoWhenMessageReceivedFromListeningRoom();
    this.deleteWSListener && this.deleteWSListener();
    this.typingTimeoutId && clearTimeout(this.typingTimeoutId);
  };

  updateDemoChatMessages = () => {
    let chatBoxMessages = [],
      messageText =
        this.props.mentor.mentorDto.appControlDto.automaticChatMessage ??
        VIDABOO_CONSTANTS.CHAT_AUTOMATIC_MSG;
    if (messageText) {
      const chat1 = {
        isDefaultDemoMsg: true,
        messageText,
        fromPeer: true,
        subType: 'text',
        senderObjectId:
          VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.AUTOMATED_MESSAGE,
        senderObjectType:
          VIDABOO_CONSTANTS.AUTOMATED_MSG_TYPES.AUTOMATIC_MESSAGE,
      };
      chatBoxMessages.push(chat1);
    }
    const chat2 = {
      isDefaultDemoMsg: true,
      messageText: "Let's make something awesome today!",
      fromPeer: true,
      sendTime: moment().valueOf(),
      subType: 'text',
    };
    const chat3 = {
      isDefaultDemoMsg: true,
      messageText: 'Sounds terrific! Where can I sign? ',
      fromPeer: false,
      sendTime: moment().add(2, 'minutes').valueOf(),
      subType: 'text',
    };
    chatBoxMessages.push(chat2, chat3);
    this.setState({
      chatBoxMessages,
    });
  };
  resetDemoChatMessages = () => {
    const chatBoxMessages = this.state.chatBoxMessages.filter(
      (chatBoxMessage) => chatBoxMessage.isDefaultDemoMsg,
    );
    this.setState({
      chatBoxMessages,
    });
  };
  getParticipantId = () => {
    const chatRoomDto = this.props.chatRoomDto;
    if (this.props.isDemo) {
      return 'chatRoomId';
    } else if (this.props.isMentor) {
      let participantId = null;
      //1. Note : we fetch the chatrooms only for the mentors who have provided access
      //2. if room is owned by mentor, then ownerObjectId is equal to participantId
      //3. if room is owned by widget
      //   3.a. if taskOwnerMentorId matches any of the authorizedSelectedMentorIds, it means mentor has taken the control of room -> so taskOwnerMentorId will be the participantId
      //   3.b. if 3.a doesn't satisfies, then we need to find the mentorDto
      //        3.b.1 if there exist a mentorDto in the currently selected mentorDtos -> use that
      //        3.b.2 otherwise select the first mentorDto that comes from the widget
      if (
        chatRoomDto.ownerObjectType ===
        VIDABOO_CONSTANTS.CHAT_ROOM_OWNER_TYPE.MENTOR
      ) {
        participantId = chatRoomDto.ownerObjectId;
      } else {
        const widgetId = expertHomeService.getWidgetDtoByTeamMentorId(
          this.props.expertHomeContext.widgetDtos,
          chatRoomDto.ownerObjectId,
        ).widgetId;

        const authorizedSelectedMentorIds =
          expertHomeService.getAuthorizedSelectedMentorIds(
            this.props.expertHomeContext.selectedMentorDtos,
          );
        participantId = authorizedSelectedMentorIds.find((mentorId) => {
          const mentorUserId =
            this.props.expertHomeContext.selectedMentorDtos[mentorId]
              ?.mentorsControlMapDto[mentorId]?.extendedMentorDto?.mentorDto
              ?.mentorOwnerId;
          return (
            mentorId === chatRoomDto.taskOwnerMentorId &&
            mentorUserId === this.myUserId
          );
        });
        if (!participantId) {
          participantId =
            expertHomeService.getFirstSelectedMentorDtoByWidgetAndUserId(
              this.props.expertHomeContext.widgetDtos,
              this.props.expertHomeContext.selectedMentorDtos,
              widgetId,
              this.myUserId,
            )?.extendedMentorDto?.mentorDto?.mentorId;
        }
        if (!participantId) {
          const mentorDto =
            expertHomeService.getFirstMentorDtoByWidgetAndUserId(
              this.props.expertHomeContext.widgetDtos,
              widgetId,
              this.myUserId,
            );
          participantId = mentorDto?.extendedMentorDto?.mentorDto?.mentorId;
        }
        if (!participantId) {
          //To get mentorId when response is coming from search API
          participantId = expertHomeService.getSelectedMentorDto(
            this.props.expertHomeContext.selectedMentorDtos,
          ).mentorId;
        }
        if (!participantId) {
          alert('Should not happen - Invalid participantId2');
        }
      }

      return participantId;
    } else {
      return this.myUserId;
    }
  };

  doWhenMessageReceivedFromPrivateRoom = (data) => {
    // const chatRoomId = data.content?.targetChatRoomId;
    if (data.senderUserId !== this.props.currentUser.userId) {
      if (
        data.messageType ===
        VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CHAT_NO_SAVE
      ) {
        if (
          data.content.SubType ===
          VIDABOO_CONSTANTS.CHAT_NO_SAVE_SUBTYPES.USER_IS_TYPING
        ) {
          this.override_peerIsTyping(data.content);
        } else if (
          data.content.SubType ===
          VIDABOO_CONSTANTS.CHAT_NO_SAVE_SUBTYPES.USER_STOPPED_TYPING
        ) {
          this.override_peerStoppedTyping(data.content);
        } else if (
          data.content.SubType ===
          VIDABOO_CONSTANTS.CHAT_NO_SAVE_SUBTYPES.MESSAGE_WAS_SEEN_BY_USER
        ) {
          this.override_doWhenPeerReadChatMessage(data.content.message);
        } else if (
          data.content.SubType ===
          VIDABOO_CONSTANTS.CHAT_NO_SAVE_SUBTYPES.DELETE_CHAT_MESSAGE // this runs for both mentor and guest!!!... senderId in this case is always server
        ) {
          const newMessages = this.state.chatBoxMessages.filter(
            (chatBoxMessage) =>
              chatBoxMessage.messageTag !== data.content.chatMessageTag,
          );
          this.setState({chatBoxMessages: newMessages});
        }
      } else if (
        data.senderUserId === 'server' &&
        data.messageType ===
          VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.AI_COMPLETION_UPDATE
      ) {
        this.doWhenOoniAiMsgReceived(data.content.chatMessageDto);
      } else if (
        data.senderUserId === 'server' &&
        data.messageType === VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CHAT &&
        [
          VIDABOO_CONSTANTS.CHAT_SUBTYPES.OONI_AI,
          VIDABOO_CONSTANTS.CHAT_SUBTYPES.HANDOFF_FLOW_START,
          VIDABOO_CONSTANTS.CHAT_SUBTYPES.HANDOFF_PENDING,
          VIDABOO_CONSTANTS.CHAT_SUBTYPES.TASK_OWNER_EVENT,
        ].includes(data.content.SubType)
      ) {
        this.doWhenOoniAiMsgReceived(data.content.chatMessageDto);
      } else if (
        data.messageType === VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CHAT &&
        ![
          VIDABOO_CONSTANTS.CHAT_SUBTYPES.TRANSITION_TO_MENTOR_CHAT_ROOM,
          VIDABOO_CONSTANTS.CHAT_SUBTYPES.TASK_OWNER_UPDATE,
        ].includes(data.content.SubType)
      ) {
        this.doWhenMessageReceivedFromPeer(data);
      }
    } else {
      console.debug('chat-box : chat not belongs here');
    }
  };

  handleWebsocketStatusChanges = () => {
    if (this.props.isDemo || utilsService.getIsClient()) return;
    if (WSService.socketEstablished() === true) {
      this.setState({isWsConnected: true});
    }
    this.deleteWSListener = WSService.addConnectionEventListener((event) => {
      if (event === VIDABOO_CONSTANTS.WS_CONNECTION_STATES.CONNECTED) {
        this.setState({isWsConnected: true});
      } else {
        this.setState({isWsConnected: false});
      }
    });
  };

  updatePrivateChatRoomName = () => {
    let {chatRoomDto} = this.state;
    chatRoomDto.participants =
      this.props.expertHomeContext.privateChatRoomDto.participants;
    this.setState({
      chatRoomDto,
      roomName: Object.keys(chatRoomDto.participants).length + ' participants',
    });
  };

  addScrollMonitor = () => {
    if (!VIDABOO_CONSTANTS.NATIVE_APP) {
      const chatboxDivId = utilsService.getFormattedId(
        VIDABOO_CONSTANTS.ID_PREFIX.CHATBOX,
        this.props.chatRoomDto.roomId,
      );
      const scroller = document.getElementById(chatboxDivId);
      scroller?.addEventListener('scroll', () => {
        this.setState({
          scrollHeight: scroller.scrollHeight,
          scrollPosition: scroller.scrollTop,
          chatboxHeight: scroller.offsetHeight,
        });
        if (
          scroller.scrollHeight - scroller.scrollTop ===
          scroller.offsetHeight
        ) {
          this.setState({popupDisplay: false});
        }
      });
    }
  };

  getMessagesHistory = (roomId) => {
    const currentPage = this.state.currentPage + 1;

    this.setState({
      showPreviousMessagesShimmer: true,
      currentPage: currentPage,
    });
    this.getMessages(roomId, currentPage);
  };

  unSubscribeToChatBridgeService = () => {
    chatBridgeService.detachChatBoxListener('doWhenNewCallRecording');
    chatBridgeService.detachChatBoxListener('doWhenStopCallRecording');
  };
  subscribeToChatBridgeService = () => {
    chatBridgeService.attachChatBoxListener(
      'doWhenNewCallRecording',
      this.doWhenNewCallRecording,
    );
    chatBridgeService.attachChatBoxListener(
      'doWhenStopCallRecording',
      this.doWhenStopCallRecording,
    );
  };
  doWhenNewCallRecording = (callRecordingDto, chatMessageId) => {
    if (this.props.chatRoomDto.roomId === callRecordingDto.chatRoomId) {
      chatService.getChatMessageByChatMessageId(
        chatMessageId,
        (chatMessageDto) => {
          const chatBoxMessages = this.state.chatBoxMessages;
          const createdChatMessageDto = chatMessageDto;
          createdChatMessageDto.sendTimeFormatted = this.formatDate(
            new Date(createdChatMessageDto.senderCreationTime),
          );
          createdChatMessageDto.subType =
            VIDABOO_CONSTANTS.CHAT_SUBTYPES.VIDEO_RECORDING;
          chatBoxMessages.push(createdChatMessageDto);
          this.setState({chatBoxMessages});
        },
      );
    } else {
      console.debug('Do nothing, you are in another chat room');
    }
  };
  doWhenStopCallRecording = () => {
    this.setState({}); // refresh chatMessages. Todo - need to actually do the refresh of the message.
  };

  registerWindowResize = () => {
    //todomcss : ok
    if (utilsService.isMobileDevice() && !VIDABOO_CONSTANTS.NATIVE_APP) {
      window.addEventListener('resize', this.handleWindowResize);
    }
  };
  handleWindowResize = () => {
    //todomcss : ok
    if (!VIDABOO_CONSTANTS.NATIVE_APP && utilsService.isMobileDevice()) {
      console.debug('resizing window ==> resizing chat');
      const chatboxDivId = utilsService.getFormattedId(
        VIDABOO_CONSTANTS.ID_PREFIX.CHATBOX,
        this.props.chatRoomDto.roomId,
      );
      Array.from(
        document.getElementsByClassName(`et-chatting-box ${chatboxDivId}`),
      ).forEach((element) => {
        element.style.height = window.innerHeight - 263 + 'px';
        // console.debug(element.style.height);
      });
      Array.from(
        document.getElementsByClassName(`et-site-visitors-section`),
      ).forEach((element) => {
        element.style.height = window.innerHeight - 103 + 'px';
        // console.debug(element.style.height);
      });
    }
  };
  initChatBox = () => {
    if (
      this.props.firstMessage !== undefined &&
      this.props.firstMessage !== null
    ) {
      const chatMessages = [...this.props.chatMessages];
      chatMessages.unshift(this.props.firstMessage);
      this.props.updateChatMessages(chatMessages);
    }

    // console.debug(this.props, 'Props from chatbox', mentorUserId);
    this.doWhenChatRoomInfoReturned(this.props.chatRoomDto);

    this.deleteDoWhenVisibilityChangeListener =
      VisibilityHandlerService.doWhenVisibilityChange((visibilityIsHidden) => {
        if (!visibilityIsHidden && this.state.expended) {
          this.state.unreadMessagesByCurrentUser.forEach((chatMessageTag) => {
            this.sendMessageWasReadByUser(chatMessageTag);
          });
          // this.state.unreadMessagesByCurrentUser = [];
          this.scrollToChatTop_Bottom();
          this.setState({
            unreadMessagesByCurrentUser: [],
            peerIsTyping: false,
          });
        }
      });
    this.pushFirstNewlyReceivedMessages();
    this.emojiPicker = React.createRef();
  };

  //find what is the last message in the messages history which was included
  //in history only and was not sent in parallel to the mentor
  //if in the future the history will become long it will be better to implement this
  //using binary search
  findLastNonCorespondingMessage = (msgsArr, msgDto) => {
    for (var i = msgsArr.length - 1; i >= 0; i--) {
      if (
        msgsArr[i].senderCreationTime === msgDto.sendTime &&
        msgsArr[i].content === msgDto.messageText
      ) {
        // Send the current index instead of i-1
        return i + 1;
      }
    }
    return msgsArr.length - 1;
  };

  //push teh messages to chat which were received before the chat controller
  //has finished to run as thus all its funnctions became defined
  pushFirstNewlyReceivedMessages = () => {
    // console.debug(this.props, this.state, 'Hello both');
    if (this.props.chatMessages.length > 0) {
      for (var i = 0; i < this.props.chatMessages.length; i++) {
        this.override_doWhenMessageReceived(this.props.chatMessages[i], true);
      }
    }

    this.setState({firstMessagesPushed: true});
    if (!this.state.chatInitialized && this.messagesHistory.length > 0) {
      this.pushMessagesHistory();
    } else if (!this.state.chatInitialized) {
      //set chat as initialized even if there are no messages in history: its required in clientChatBox
      this.setState({chatInitialized: true});
    }
  };

  //push the messages history to chat box
  pushMessagesHistory = (currentPage) => {
    var lastUniqueMsgIndex = this.messagesHistory.length - 1;
    let lastUniqueMsgIndexFromNonCorespondingMsg = 0;
    let lastUniqueMsgIndexFromNonCorespondingMsgFlag = false;

    if (
      this.state.chatBoxMessages.length > 0 && // we have a few chats in the chatbox.
      this.messagesHistory.length > 0 // we have previously-saved chats in the chatbox (fetched by server)
    ) {
      lastUniqueMsgIndexFromNonCorespondingMsg =
        this.findLastNonCorespondingMessage(
          this.messagesHistory,
          this.state.chatBoxMessages[0],
        );
      lastUniqueMsgIndexFromNonCorespondingMsgFlag = true;
    }
    for (
      let i = lastUniqueMsgIndex;
      i >= lastUniqueMsgIndexFromNonCorespondingMsg;
      i--
    ) {
      var chatMessageDto = this.messagesHistory[i];
      var chatMessageObj = {};
      chatMessageObj.sendTime = chatMessageDto.senderCreationTime;
      chatMessageObj.subType = chatMessageDto.contentType; // In REST we save type as "contentType". when sending message to peer, it's sent as SubType
      chatMessageObj.metaData = chatMessageDto.metaData;
      chatMessageObj.messageTag = chatMessageDto.messageTag;
      chatMessageObj.messageText = chatMessageDto.content;
      chatMessageObj.senderObjectId = chatMessageDto.senderObjectId;
      chatMessageObj.senderObjectType = chatMessageDto.senderObjectType;
      chatMessageObj.chatMessageId = chatMessageDto.chatMessageId;

      // chatMessageObj.messageText = this.msgIsLink(chatMessageDto.content);

      chatMessageObj.fromPeer =
        chatMessageDto.senderObjectId !== this.myParticipantId ? true : false;
      // chatMessageObj.messageTextIsLink = this.msgIsLink(
      //   chatMessageObj.messageText
      // );
      chatMessageObj.messageWasRead = false;
      if (!chatMessageObj.fromPeer) {
        // var readersHash = chatMessageDto.readersMap;
        // const readersHashValue = Object.values(readersHash);
        // //if the peer already saw this message in the past
        // // id 0 means message is unread
        // if (readersHashValue.indexOf(0) === -1) {
        //   //in case of multiple users chat - there will be a need to check that all the participants read the message
        //   chatMessageObj.messageWasRead = true;
        // }
        let readersHash = {...chatMessageDto.readersMap};
        chatMessageObj.messageWasRead = Object.keys(readersHash).some(
          (userId) =>
            userId !== this.props.currentUser.userId && readersHash[userId] > 0,
        );
        if (!chatMessageObj.messageWasRead) {
          //if it was not read in the past check maybe it was read after pull from history
          for (
            var j = 0;
            j < this.props.readMessagesByMessageTag?.length;
            j++
          ) {
            if (
              chatMessageObj.messageTag ===
              this.props.readMessagesByMessageTag[j]
            ) {
              chatMessageObj.messageWasRead = true;
              this.props.readMessagesByMessageTag.splice(j, 1);
            }
          }
        }
      }
      if (chatMessageObj.fromPeer) {
        let readersHash = chatMessageDto.readersMap;
        let messageWasReadByMe =
          readersHash &&
          readersHash[this.myUserId] &&
          readersHash[this.myUserId] !== 0;
        // let messageWasReadByMe = false;
        // readersHash &&
        //   Object.entries(readersHash).forEach((entry) => {
        //     //if the peer already saw this message in the past
        //     if (entry[0] === this.props.currentUser.userId && entry[1] !== 0) {
        //       messageWasReadByMe = true;
        //     }
        //   });
        if (!messageWasReadByMe) {
          if (VisibilityHandlerService.getIsVisibilityHidden()) {
            // this.state.unreadMessagesByCurrentUser.push(
            //   chatMessageDto.senderCreationTime
            // );
            this.setState({
              unreadMessagesByCurrentUser: [
                ...this.state.unreadMessagesByCurrentUser,
                chatMessageDto.messageTag,
              ],
            });
          } //send that all of these were read when the chat will be visible
          else {
            //send message to peer that this message was read and update in REST server
            this.sendMessageWasReadByUser(chatMessageDto.messageTag);
          }
        }
      }
      this.pushMessageTomessages(chatMessageObj, true);
    }
    if (lastUniqueMsgIndexFromNonCorespondingMsgFlag) {
      const chatBoxMessages = this.state.chatBoxMessages;
      // Move last to first
      chatBoxMessages.unshift(chatBoxMessages.pop());
      this.setState({chatBoxMessages});
    }
    this.updatePeerInfoBasedOnLeadCollector(this.props.chatRoomDto);
    // console.debug('Inside here');
    if (!currentPage) {
      this.scrollToChatTop_Bottom();
    } else {
      this.scrollToChatTop_Bottom(true);
    }

    this.setState({chatInitialized: true});
  };

  scrollToChatTop_Bottom = (top) => {
    if (!VIDABOO_CONSTANTS.NATIVE_APP) {
      if (this.scrollSetTimeout) {
        clearTimeout(this.scrollSetTimeout);
      }
      this.scrollSetTimeout = setTimeout(
        () => {
          const chatboxDivId = utilsService.getFormattedId(
            VIDABOO_CONSTANTS.ID_PREFIX.CHATBOX,
            this.props.chatRoomDto.roomId,
          );
          const scroller = document.getElementById(chatboxDivId);
          if (scroller) {
            if (top) {
              scroller.scrollTop = 0;
            } else {
              // we might be moving from tab to tab and this could come late.
              scroller.scrollTop = scroller.scrollHeight;
            }
          }
        },
        0,
        false,
      );
    }
  };
  // msgIsLink = messageContent => {
  //   return messageContent;
  //   const pattern = VIDABOO_CONSTANTS.VALIDATION_PATTERNS.ANY_URL;
  //   let changes = messageContent.split(" ").map(content => {
  //     console.debug("in");
  //     if (
  //       pattern.test(content) &&
  //       (content.includes("/") || content.includes("."))
  //     ) {
  //       console.debug("inside if");
  //       return `<a href=${content} target="_blank">${content}</a>`;
  //     } else return content;
  //   });

  //   let modifiedContent = changes.join(" ");
  //   return modifiedContent;
  // };
  //   var pattern = new RegExp(
  //     "^(https?:\\/\\/)?" + // protocol
  //     "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|" + // domain name
  //     "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
  //     "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
  //     "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
  //       "(\\#[-a-z\\d_]*)?$",
  //     "i"
  //   ); // fragment locator

  //   if (
  //     pattern.test(messageContent) &&
  //     (messageContent.includes("/") || messageContent.includes("."))
  //   ) {
  //     return true;
  //   }
  //   return false;
  // };

  beepForArrivingMessage() {
    if (VisibilityHandlerService.getIsVisibilityHidden()) {
      const storageChatBeepSound = storageService.getItem('chatBeepSound');
      const chatBeepSound = JSON.parse(storageChatBeepSound ?? true);
      if (chatBeepSound !== false) {
        if (VIDABOO_CONSTANTS.NATIVE_APP) {
          this.setState({
            audioPaused: false,
          });
        } else {
          audioFileService.playOrGetAudioFile(
            VIDABOO_CONSTANTS.AUDIO_SOUND_TYPES.CHAT_AUDIO,
            false,
            {volume: 0.4},
          );
        }
      }
    }
  }

  clearMessageToBeSendQueue = () => {
    const msgQueue = this.state.messageToBeSendQueue;
    msgQueue.forEach((msg) => {
      this.sendMessage(msg.messageText, msg.subType, msg.metaData);
    });
    this.setState({messageToBeSendQueue: []});
  };
  doWhenChatRoomInfoReturned = (chatRoomDto) => {
    if (utilsService.getIsClient()) {
      this.props.widgetContext.setChatRoomId(chatRoomDto.roomId);
    }
    this.setState({chatRoomDto});
    // ClearMessage to be send queue
    this.clearMessageToBeSendQueue();

    // console.debug('doWhenChatRoomInfoReturned->chatRoomDto = ', chatRoomDto);
    if (this.props.currentUser.guest !== true) {
      // chatService.getMessagesByChatRoomId(
      //   chatRoomDto.roomId,
      //   this.doWhenChatMessagesReturned,
      // );
      this.setState({showChatBoxMessagesShimmer: true});
      this.getMessages(chatRoomDto.roomId, this.state.currentPage);
    }
    if (this.props.currentUser.guest === true) {
      chatService.getGuestMessagesByChatRoomId(
        chatRoomDto.roomId,
        this.myUserId,
        this.doWhenChatMessagesReturned,
      );
      // console.debug("check local storage");
      // //var s = StorageService.getChat(this.myUserId,contScope.chatRoomDto.roomId);
      // //this.doWhenChatMessagesReturned(s);
    }
    this.setRoomAndParticipantNamesFromChatRoom(chatRoomDto);
  };

  getMessages = (roomId, currentPage) => {
    chatService.getAllMessagesByChatRoomId(
      roomId,
      currentPage,
      PAGE_SIZE,
      (response) => this.doWhenChatMessagesReturned(response, currentPage),
    );
  };
  reloadChatBoxMessages = () => {
    this.setState(
      {
        allChatMessages: [],
        chatBoxMessages: [],
        currentPage: 0,
      },
      () => {
        this.doWhenChatRoomInfoReturned(this.props.chatRoomDto);
      },
    );
  };
  setRoomAndParticipantNamesFromChatRoom(chatRoomDto) {
    if (this.isMentor === true) {
      //default values
      let roomName =
        chatRoomDto.roomType === VIDABOO_CONSTANTS.CHAT_ROOM_TYPES.ONE_TO_MANY
          ? Object.keys(chatRoomDto.participants).length + ' participants'
          : chatRoomDto.ownerObjectType ===
              VIDABOO_CONSTANTS.CHAT_ROOM_OWNER_TYPE.TEAM_MENTOR
            ? 'Guest'
            : 'Guest';
      if (chatRoomDto.roomInfoDto?.roomName) {
        roomName = chatRoomDto.roomInfoDto.roomName;
      } else if (chatRoomDto.chatRoomPeerInfoDto?.peerName) {
        roomName = chatRoomDto.chatRoomPeerInfoDto.peerName;
      } else if (chatRoomDto.chatRoomPeerInfoDto?.peerEmail) {
        roomName = chatRoomDto.chatRoomPeerInfoDto.peerEmail;
      }
      const authorizedMentorIds =
        expertHomeService.getAuthorizedSelectedMentorIds(
          this.props.expertHomeContext.selectedMentorDtos,
        );
      chatRoomDto.participantsInfo = expertHomeService.getChatParticipantsInfo({
        roomDto: chatRoomDto,
        chatRooms: this.props.chatRooms,
        widgetDtos: this.props.expertHomeContext.widgetDtos,
        authorizedMentorIds,
        currentUserId: this.props.currentUser.userId,
      });

      this.setState({roomName});
    } else {
      this.setState({roomName: this.props.peerName});
    }
  }
  doWhenChatRoomInfoReturnedFail = (/* chatRoomDto */) => {
    // console.debug("doWhenChatRoomInfoReturnedFail ->", chatRoomDto);
    this.setState({failRespone: true});
  };
  doWhenChatMessagesReturned = (chatMessagesDto, currentPage) => {
    const {allChatMessages} = this.state;
    if (chatMessagesDto.length < PAGE_SIZE) {
      this.setState({showLoadMore: false});
    } else {
      this.setState({showLoadMore: true});
    }

    if (
      chatMessagesDto !== null &&
      chatMessagesDto !== undefined &&
      chatMessagesDto.length > 0
    ) {
      const messages = allChatMessages.slice();
      const allMessages = [...messages, ...chatMessagesDto];
      //todomcss : ok
      const isInMobile = utilsService.isMobileDevice();
      const sortedMessages = allMessages.sort(this.compareChatMessageDto);
      if (isInMobile) {
        this.messagesHistory = chatMessagesDto.sort(this.compareChatMessageDto);
      } else {
        this.setState({
          messagesHistory: chatMessagesDto.sort(this.compareChatMessageDto),
        });
        this.messagesHistory = sortedMessages;
      }

      this.setState({
        allChatMessages: this.messagesHistory,
        chatBoxMessages: [],
      });

      // console.debug(contScope.messagesHistory[contScope.messagesHistory.length - 1]);
      // console.debug(this.state.chatBoxMessages[0]);
      if (this.state.firstMessagesPushed) {
        this.pushMessagesHistory(currentPage);
      }
    } else {
      if (
        this.props.automaticMessage !== undefined &&
        this.props.automaticMessage !== null
      ) {
        let automaticMessageObj = {
          content: this.createChatMessageData(this.props.automaticMessage),
          // senderUserId: 'automaticMessage',
          senderObjectId:
            VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.AUTOMATED_MESSAGE,
        };
        automaticMessageObj.content.senderObjectId =
          VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.AUTOMATED_MESSAGE;
        automaticMessageObj.content.senderObjectType =
          VIDABOO_CONSTANTS.AUTOMATED_MSG_TYPES.AUTOMATIC_MESSAGE;
        this.override_doWhenMessageReceived(automaticMessageObj);
      }
    }
    this.setState({
      showChatBoxMessagesShimmer: false,
      showPreviousMessagesShimmer: false,
    });
    // if(this.props.isMentor !== true && this.props.currentUser.role === "GUEST"){
    //     console.debug("check local storage");
    // }
  };

  goToChatEnd = () => {
    this.scrollToChatTop_Bottom();
    this.setState({showNewMsgPopup: false});
  };

  override_scrollBehaviour = () => {
    const {scrollHeight, scrollPosition, chatboxHeight} = this.state;
    if (scrollHeight - scrollPosition > chatboxHeight * 1.5) {
      // console.debug('you were in the middle of the chat')
      this.setState({showNewMsgPopup: true});
    } else {
      // console.debug('you were at the bottom of the chat')
      this.setState({showNewMsgPopup: false});
      return this.scrollToChatTop_Bottom();
    }
  };
  expandChatBox = () => {
    // alert("expandChatBox in chatBox");
    this.props.fncObj.expandChatBox && this.props.fncObj.expandChatBox();
    this.setState({
      expended: true,
    });

    this.inputFocus();
    if (!VisibilityHandlerService.getIsVisibilityHidden()) {
      this.state.unreadMessagesByCurrentUser.forEach(function (element) {
        this.sendMessageWasReadByUser(element);
      });
      // this.unreadMessagesByCurrentUser = [];
      this.setState({unreadMessagesByCurrentUser: []});
    }
    this.override_scrollBehaviour();
  };
  inputFocus = () => {
    if (this.state.expended === true) {
      // var ele = angular.element(".et-chb-text-input-focus");
    }
  };
  doWhenOoniAiDemoResponseReceived = ({metaData}) => {
    // find the existing ooni message and update it
    const llmCompletionFlowId = metaData.llmCompletionFlowId;
    let chatBoxMessages = [...this.state.chatBoxMessages];
    const existingAiChatMsgIdx = chatBoxMessages.findIndex(
      (chatMessage) =>
        chatMessage.chatMessageId === llmCompletionFlowId &&
        chatMessage.senderObjectType ===
          VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.OONI_AI,
    );
    if (existingAiChatMsgIdx === -1) {
      const demoChatMessage = {
        senderObjectType: VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.OONI_AI,
        chatMessageId: metaData.llmCompletionFlowId,
        metaData: JSON.stringify(metaData),
        messageText: null,
        subType: VIDABOO_CONSTANTS.CHAT_SUBTYPES.OONI_AI,
        fromPeer: true,
        sendTime: moment().valueOf(),
      };
      this.setState({
        chatBoxMessages: [...this.state.chatBoxMessages, demoChatMessage],
      });
    } else {
      let existingAiChatMessage = {...chatBoxMessages[existingAiChatMsgIdx]};
      existingAiChatMessage.messageText = metaData.content;
      existingAiChatMessage.metaData = JSON.stringify(metaData);
      chatBoxMessages[existingAiChatMsgIdx] = existingAiChatMessage;
      this.setState({chatBoxMessages});
    }
    this.goToChatEnd();
  };
  doWhenOoniAiMsgReceived = (chatMessageDto) => {
    // todo 1720 : Ilan/Jashan verify analytics event needs to be trigger in this case

    let chatBoxMessages = [...this.state.chatBoxMessages];
    const existingAiChatMsgIdx = chatBoxMessages.findIndex(
      (chatMessage) => chatMessage.messageTag === chatMessageDto.messageTag,
    );
    if (existingAiChatMsgIdx !== -1) {
      // update content and meta data
      let existingAiChatMessage = {...chatBoxMessages[existingAiChatMsgIdx]};
      existingAiChatMessage.messageText = chatMessageDto.content;
      existingAiChatMessage.metaData = chatMessageDto.metaData;
      existingAiChatMessage.isMsgAddedOrUpdatedViaWs = true;
      chatBoxMessages[existingAiChatMsgIdx] = existingAiChatMessage;
      this.setState({chatBoxMessages});
    } else {
      // create new message
      let chatMessage = {content: {}};
      chatMessage.content.chatMessageId = chatMessageDto.chatMessageId;
      chatMessage.content.senderCreationTime =
        chatMessageDto.senderCreationTime;
      chatMessage.content.message = chatMessageDto.content;
      chatMessage.content.senderObjectId = chatMessageDto.senderObjectId;
      chatMessage.content.senderObjectType = chatMessageDto.senderObjectType;
      chatMessage.content.messageTag = chatMessageDto.messageTag;
      chatMessage.content.metaData = chatMessageDto.metaData;
      chatMessage.content.SubType = chatMessageDto.contentType;
      chatMessage.content.isMsgAddedOrUpdatedViaWs = true;
      this.doWhenMessageReceivedFromPeer(chatMessage);
    }
  };
  doWhenMessageReceivedFromPeer = (chatMessage) => {
    this.dispatchConsoltoEvents(
      VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.CHAT_MESSAGE_RECEIVED,
    );
    this.override_doWhenMessageReceived(chatMessage, false);
    if (
      !this.props.isDemo &&
      utilsService.getIsClient() &&
      this.context.callState === VIDABOO_CONSTANTS.VIDEO_CALL_STATE.INIT //if callState is not init, messageNotificationOnWebCall will be mounted which will handle message cue
    ) {
      if (
        this.props.selectedWidgetAppType ===
        VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT
      ) {
        this.context.setChatMessageCueCounter(true);
        this.context.setChatMessageCue(false);
      } else {
        this.context.setChatMessageCueCounter();
        this.context.setChatMessageCue(true);
      }
    }
  };
  override_doWhenMessageReceived = (chatMessage, isFromMsgsQue) => {
    if (!isFromMsgsQue && !this.state.firstMessagesPushed) {
      const chatMessages = [...this.props.chatMessages];
      chatMessages.push(chatMessage);

      this.props.updateChatMessages(chatMessages);
      return;
    }
    if (
      chatMessage.content.senderObjectId === this.myParticipantId &&
      chatMessage.content.SubType !==
        VIDABOO_CONSTANTS.CHAT_SUBTYPES.MONEY_TRANSACTION
    ) {
      //console.debug("User got message from himself!!");
      return;
    }
    this.expandChatBox();
    if (!this.state.showMessages || this.state.needToReset) {
      // contScope.messageCounter++;
      const messageCounter = this.state.messageCounter + 1;
      // messageCounter+;
      this.setState({messageCounter});
    }

    var chatMessageObj = {};
    if (chatMessage.senderObjectId === this.myParticipantId) {
      var i = this.props.readMessagesByMessageTag.indexOf(
        chatMessage.content.chatMessageTag,
      );
      if (i > -1) {
        chatMessageObj.messageWasRead = true;
        let updateReadMessagesByMessageTag = [
          ...this.props.readMessagesByMessageTag,
        ];
        updateReadMessagesByMessageTag.splice(i, 1);
        this.props.updateReadMessagesByMessageTag(
          updateReadMessagesByMessageTag,
        );
      }
    }
    chatMessageObj.sendTime = chatMessage.content.senderCreationTime;
    chatMessageObj.messageText = chatMessage.content.message;
    // chatMessageObj.messageText = this.msgIsLink(chatMessage.content.message);
    chatMessageObj.fromPeer =
      chatMessage.content.senderObjectId !== this.myParticipantId;
    chatMessageObj.senderObjectId = chatMessage.content.senderObjectId;
    chatMessageObj.senderObjectType = chatMessage.content.senderObjectType;
    chatMessageObj.messageTag = chatMessage.content.messageTag;
    chatMessageObj.metaData = chatMessage.content.metaData;
    chatMessageObj.subType = chatMessage.content.SubType;

    if (chatMessage.content.chatMessageId) {
      chatMessageObj.chatMessageId = chatMessage.content.chatMessageId;
    }
    if (chatMessage.content.chatMessageId) {
      chatMessageObj.isMsgAddedOrUpdatedViaWs =
        chatMessage.content.isMsgAddedOrUpdatedViaWs;
    }

    // contScope.peerDidNotRespond = false;
    this.setState({peerDidNotRespond: false, peerIsTyping: false});
    // console.debug('***** 2');
    // contScope.peerIsTyping = false;

    // console.debug("chatMessageObj here is", chatMessageObj);
    // chatMessageObj.messageTextIsLink = this.msgIsLink(
    //   chatMessageObj.messageText
    // );
    this.pushMessageTomessages(chatMessageObj);
    if (
      chatMessage.senderObjectId !==
      VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.AUTOMATED_MESSAGE
    ) {
      if (VisibilityHandlerService.getIsVisibilityHidden()) {
        // contScope.unreadMessagesByCurrentUser.push(
        //   chatMessage.content.senderCreationTime
        // );
        this.setState({
          unreadMessagesByCurrentUser: [
            ...this.state.unreadMessagesByCurrentUser,
            chatMessage.content.messageTag,
          ],
        });
      } else {
        //send message to peer that this message was read and update in REST server
        this.sendMessageWasReadByUser(chatMessage.content.messageTag);
        this.setState({peerIsTyping: false});
      }
    }
    this.beepForArrivingMessage();
  };

  waitForPeerResponse = () => {
    if (
      this.props.chatRoomDto.ownerObjectType ===
      VIDABOO_CONSTANTS.CHAT_ROOM_OWNER_TYPE.TEAM_MENTOR
    )
      return;

    const now = new Date().getTime();

    this.waitForPeerResponseTimeout = null;
    var chatLcpHistory = storageService.getItem('chatLcp');
    // chat last conversation with peer
    var chatLcpHistoryHash = utilsService.isLocalStorageSupported()
      ? JSON.parse(chatLcpHistory)
      : {};
    if (!chatLcpHistoryHash) chatLcpHistoryHash = {};
    if (
      !this.state.nonRespondedMessageSent &&
      (!chatLcpHistoryHash[this.props.chatRoomDto.ownerObjectId] ||
        now - chatLcpHistoryHash[this.props.chatRoomDto.ownerObjectId] >
          VIDABOO_CONSTANTS.CHAT_AUTO_RESPONDER.DEFAULT_TIME_BETWEEN_AUTO_CHATS)
    ) {
      if (this.waitForPeerResponseTimeout)
        // $timeout.cancel(waitForPeerResponseTimeout);
        clearTimeout(this.waitForPeerResponseTimeout);
      // contScope.peerDidNotRespond = true;
      this.setState({peerDidNotRespond: true});
      this.waitForPeerResponseTimeout = setTimeout(() => {
        if (this.state.peerDidNotRespond === true) {
          if (this.props.nonRespondantMessage) {
            let automaticMessageObj = {
              content: this.createChatMessageData(
                this.props.nonRespondantMessage,
              ),
              // senderUserId:
              //   VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.AUTOMATED_MESSAGE,
              senderObjectId:
                VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.AUTOMATED_MESSAGE,
            };
            automaticMessageObj.content.senderObjectId =
              VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.AUTOMATED_MESSAGE;
            automaticMessageObj.content.senderObjectType =
              VIDABOO_CONSTANTS.AUTOMATED_MSG_TYPES.NON_RESPONDANT_MESSAGE;
            this.setState({
              nonRespondedMessageSent: true,
            });
            this.override_doWhenMessageReceived(automaticMessageObj);
          }
        }
        chatLcpHistoryHash[this.props.chatRoomDto.ownerObjectId] =
          new Date().getTime();
        storageService.setItem('chatLcp', JSON.stringify(chatLcpHistoryHash));
      }, this.props.nonRespondantMessageTime);
    }
  };
  closeLeadCollectorPopup = () => {
    // contScope.leadCollectorPopup = false;
    this.setState({leadCollectorPopup: false});
  };

  onKeyDown = (event) => {
    if (!this.isCustomerAvailableForInteraction()) return;
    if (event.keyCode === 13 && event.shiftKey) {
      event.preventDefault();
      this.setState(({messageToSend}) => {
        return {messageToSend: messageToSend + '\n'};
      });
    } else if (event.keyCode === 13) {
      event.preventDefault();
      const isGroupChatRoom =
        this.props.chatRoomDto.roomType ===
        VIDABOO_CONSTANTS.CHAT_ROOM_TYPES.ONE_TO_MANY;
      const showSendEmailPopUp = !isGroupChatRoom;
      this.sendMessage(
        this.state.messageToSend,
        null,
        null,
        showSendEmailPopUp,
      );
    } else {
      this.sendUserIsTyping();
    }
  };
  sendAudioMessageNotification = (messageId) => {
    // console.debug(messageId);
    this.sendMessage(
      'Audio message',
      VIDABOO_CONSTANTS.CHAT_SUBTYPES.AUDIO_MESSAGE,
      messageId,
    );
  };

  sendMessage = async (
    messageText,
    subType,
    metaData,
    showSendEmailPopUp,
    isEmailBtnFlow,
  ) => {
    if (this.props.isDemo) {
      this.sendDemoChatMessage(messageText);
      return;
    }
    if (this.isMentor) {
      this.setState({chatMarketingParams: true});
      // Send request to N1 server. N1 is responsible for verifying if need to send to Zapier.
      // try {
      //   marketingParametersService.updateMarketingParameters(
      //     'PERSONAL',
      //     this.context.currentUser.userId,
      //     {
      //       param: VIDABOO_CONSTANTS.MARKETING_EVENT_TYPES.USER_USED_CHAT,
      //     },
      //   );
      // } catch (err) {
      //   console.debug('Error 101 in sendMessage: ', err);
      // }
    }

    //On mentor side, if the client is not available then show the email popup
    if (this.isMentor && showSendEmailPopUp) {
      this.props.setOfflineClientRoomDto(
        this.props.roomDtoFromChatCenter,
        messageText,
        isEmailBtnFlow,
      );
      return;
    }

    // Check if roomid is available, if not then add to queue
    if (this.props.chatRoomDto === undefined) {
      const msgQueue = [...this.state.messageToBeSendQueue];
      msgQueue.push({messageText, subType, metaData});
      this.setState({messageToBeSendQueue: msgQueue});
      return;
    }
    if (messageText === '' || messageText === undefined) return;
    // var sendTime = new Date().getTime();
    var chatMessageObj = {};
    chatMessageObj.messageText = messageText;
    // chatMessageObj.messageText = this.msgIsLink(messageText);
    chatMessageObj.fromPeer = false;

    const chatMessageToSend = this.createChatMessageData(messageText, subType);

    if (metaData) chatMessageToSend.metaData = metaData;
    chatMessageObj.sendTime = chatMessageToSend.senderCreationTime;
    chatMessageObj.messageTag = chatMessageToSend.messageTag;
    chatMessageObj.subType = chatMessageToSend.SubType;
    chatMessageObj.metaData = chatMessageToSend.metaData;
    chatMessageObj.senderObjectId = chatMessageToSend.senderObjectId;
    chatMessageObj.senderObjectType = chatMessageToSend.senderObjectType;
    this.pushMessageTomessages(chatMessageObj);
    const WsMsgType =
      chatMessageToSend.SubType !==
      VIDABOO_CONSTANTS.CHAT_SUBTYPES.NOTES_MESSAGE
        ? VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CHAT
        : VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CHAT_NO_PASS;
    PrivateRoomService.publishToPrivateRoom(
      chatMessageToSend,
      this.myUserId,
      this.props.chatRoomDto.roomId,
      WsMsgType,
    );
    this.setState({messageToSend: ''});
    if (this.isMentor !== true) {
      // initiated message from client or from automaticMessage. Hence, once this user sends a message and isn't getting a message back after X seconds,
      // we need to popup a "lead collector"
      if (this.props.nonRespondantMessage !== '') this.waitForPeerResponse();
    }
    if (this.isMentor) {
      this.props.updateChatRoomLastMessage(
        this.props.chatRoomDto.roomId,
        chatMessageObj.subType,
        messageText,
      );
    }

    if (!this.isMentor) {
      if (
        chatMessageToSend.SubType ===
        VIDABOO_CONSTANTS.CHAT_SUBTYPES.TEXT_MESSAGE
      ) {
        this.dispatchConsoltoEvents(
          VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.CHAT_MESSAGE_SENT,
        );
      }

      let clientLastMessageWithChatRoom = storageService.getItem(
        VIDABOO_CONSTANTS.LOCAL_STORAGE_ITEMS.CUSTOMER_LAST_MSG_WITH_CHAT_ROOM,
      );
      clientLastMessageWithChatRoom = utilsService.isLocalStorageSupported()
        ? JSON.parse(clientLastMessageWithChatRoom)
        : {};
      if (!clientLastMessageWithChatRoom) clientLastMessageWithChatRoom = {};
      if (
        clientLastMessageWithChatRoom[this.props.chatRoomDto.roomId] ===
        undefined
      ) {
        const firstChatMsg = this.state.chatBoxMessages.find(
          (chatBoxMessage) => !chatBoxMessage.fromPeer,
        );
        if (!firstChatMsg) {
          this.sendGA(
            VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.CHAT.CLIENT_START_CHAT,
          );
          clientLastMessageWithChatRoom[this.props.chatRoomDto.roomId] =
            new Date().getTime();
          storageService.setItem(
            VIDABOO_CONSTANTS.LOCAL_STORAGE_ITEMS
              .CUSTOMER_LAST_MSG_WITH_CHAT_ROOM,
            JSON.stringify(clientLastMessageWithChatRoom),
          );
        } else {
          clientLastMessageWithChatRoom[this.props.chatRoomDto.roomId] =
            firstChatMsg.sendTime;
          storageService.setItem(
            VIDABOO_CONSTANTS.LOCAL_STORAGE_ITEMS
              .CUSTOMER_LAST_MSG_WITH_CHAT_ROOM,
            JSON.stringify(clientLastMessageWithChatRoom),
          );
        }
      }
    } else {
      let mentorLastMessageWithChatRoom = storageService.getItem(
        VIDABOO_CONSTANTS.LOCAL_STORAGE_ITEMS.MENTOR_LAST_MSG_WITH_CHAT_ROOM,
      );
      mentorLastMessageWithChatRoom = utilsService.isLocalStorageSupported()
        ? JSON.parse(mentorLastMessageWithChatRoom)
        : {};
      if (!mentorLastMessageWithChatRoom) mentorLastMessageWithChatRoom = {};
      if (
        mentorLastMessageWithChatRoom[this.props.chatRoomDto.roomId] ===
        undefined
      ) {
        const firstChatMsg = this.state.chatBoxMessages.find(
          (chatBoxMessage) => !chatBoxMessage.fromPeer,
        );
        if (!firstChatMsg) {
          this.sendGA(
            VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.CHAT.MENTOR_START_CHAT,
          );
          mentorLastMessageWithChatRoom[this.props.chatRoomDto.roomId] =
            new Date().getTime();
          storageService.setItem(
            VIDABOO_CONSTANTS.LOCAL_STORAGE_ITEMS
              .MENTOR_LAST_MSG_WITH_CHAT_ROOM,
            JSON.stringify(mentorLastMessageWithChatRoom),
          );
        } else {
          mentorLastMessageWithChatRoom[this.props.chatRoomDto.roomId] =
            firstChatMsg.sendTime;
          storageService.setItem(
            VIDABOO_CONSTANTS.LOCAL_STORAGE_ITEMS
              .MENTOR_LAST_MSG_WITH_CHAT_ROOM,
            JSON.stringify(mentorLastMessageWithChatRoom),
          );
        }
      }
    }
  };

  sendDemoChatMessage = (messageText) => {
    const selectedWidgetDto = expertHomeService.getSelectedWidgetDto(
      this.props.expertHomeContext.selectedMentorDtos,
    );
    const selectedMentorDto = expertHomeService.getSelectedMentorDto(
      this.props.expertHomeContext.selectedMentorDtos,
    );
    const isTeamMentorDtoSelected =
      expertHomeService.getIsTeamMentorDtoSelected(
        this.props.expertHomeContext.selectedMentorDtos,
      );
    const demoChatMessage = {
      senderObjectType: VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.MENTOR,
      messageText,
      fromPeer: false,
      sendTime: moment().valueOf(),
      subType: VIDABOO_CONSTANTS.CHAT_SUBTYPES.TEXT_MESSAGE,
    };
    let chatBoxMessages = [...this.state.chatBoxMessages, demoChatMessage];
    this.setState({
      messageToSend: '',
      chatBoxMessages,
    });
    this.goToChatEnd();

    if (
      !this.props.chatbotContext.brainDto ||
      !expertHomeService.getIsOoniEnabledForMentor(
        selectedWidgetDto,
        selectedMentorDto.mentorId,
      )
    ) {
      return;
    }

    const ownerObjectType = isTeamMentorDtoSelected
      ? VIDABOO_CONSTANTS.BRAIN_OWNER_OBJECT_TYPES.TEAM_MENTOR
      : VIDABOO_CONSTANTS.BRAIN_OWNER_OBJECT_TYPES.MENTOR;
    const conversationContextDto = {
      chatHistory: expertHomeService.getOoniChatHistoryStr(chatBoxMessages),
      userQuery: {
        content: messageText,
      },
    };
    const chatRoomId = 'DEMO_CHAT_ROOM';
    aiCompletionService.generateCompletion(
      ownerObjectType,
      selectedMentorDto.mentorId,
      selectedWidgetDto.widgetId,
      chatRoomId,
      conversationContextDto,
    );
  };

  sendCA = (eventAction) => {
    var error = false;
    AnalyticsService.saveConsoltoAnalyticsEvent({
      category: VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.CHAT,
      action: eventAction,
      senderCreationTime: new Date().getTime(),
      userId: this.props.currentUser.userId,
      mentorId: this.props.chatRoomDto.ownerObjectId,
      userRole: this.props.currentUser.role,
      error: error,
      dimensionsMap: {
        senderIsMentor: this.isMentor,
        widget: utilsService.getIsInWidget(),
      },
    });
  };
  sendGA = (eventAction) => {
    AnalyticsService.trackEvent({
      category: VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.CHAT,
      action: eventAction,
      label: this.isMentor
        ? this.context.currentUser.userId
        : this.props.mentor.mentorDto.profileName,
      value: '',
      sendToParent: this.props.sendAnalyticsToParent === true, // send indication only if this chat box is within the widget && mentor enabled sending analytics events
    });
    this.sendCA(eventAction);
  };
  dispatchConsoltoEvents = (eventAction) => {
    if (!this.props.mentor?.mentorDto?.profileName) return; // todo 2089 : handle widget type
    this.props.dispatchConsoltoEvents &&
      this.props.dispatchConsoltoEvents(
        eventAction,
        this.props.mentor.mentorDto.profileName,
      );
  };
  sendUserIsTyping = () => {
    if (this.props.isDemo || this.isUserTyping) return;
    if (this.typingTimeoutId) {
      clearTimeout(this.typingTimeoutId);
    }

    this.isUserTyping = true;
    var chatMessageToSend = this.createChatMessageData(
      '',
      VIDABOO_CONSTANTS.CHAT_NO_SAVE_SUBTYPES.USER_IS_TYPING,
      VIDABOO_CONSTANTS.PRIVATE_ROOM_DESTINATION_GROUPS.ACTIVE_LISTENERS_ONLY,
    );
    PrivateRoomService.publishToPrivateRoom(
      chatMessageToSend,
      this.myUserId,
      this.props.chatRoomDto.roomId,
      VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CHAT_NO_SAVE,
    );

    this.typingTimeoutId = setTimeout(() => {
      this.isUserTyping = false;
    }, VIDABOO_CONSTANTS.PEER_IS_TYPING_INDICATION_TIME - 2000);
  };
  sendUserStoppedTyping = () => {
    if (this.props.isDemo) return;
    var chatMessageToSend = this.createChatMessageData(
      '',
      VIDABOO_CONSTANTS.CHAT_NO_SAVE_SUBTYPES.USER_STOPPED_TYPING,
      VIDABOO_CONSTANTS.PRIVATE_ROOM_DESTINATION_GROUPS.ACTIVE_LISTENERS_ONLY,
    );
    PrivateRoomService.publishToPrivateRoom(
      chatMessageToSend,
      this.myUserId,
      this.props.chatRoomDto.roomId,
      VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CHAT_NO_SAVE,
    );
  };
  sendMessageWasReadByUser = (chatMessageTag) => {
    if (this.props.isDemo) return;
    if (this.props.chatBoxIsHidden) return;
    if (!this.state.sentReadMessages.hasOwnProperty(chatMessageTag)) {
      // this.state.sentReadMessages[senderCreationTime] = "";
      let sentReadMessages = {...this.state.sentReadMessages};
      sentReadMessages[chatMessageTag] = 'sent';
      this.setState({sentReadMessages});
      chatService.toggleMessageWasRead(
        chatMessageTag,
        this.myUserId,
        true,
        this.doWhenMessagesWasReadSuccessfully,
      );
      var chatMessageToSend = this.createChatMessageData(
        chatMessageTag,
        VIDABOO_CONSTANTS.CHAT_NO_SAVE_SUBTYPES.MESSAGE_WAS_SEEN_BY_USER,
        VIDABOO_CONSTANTS.PRIVATE_ROOM_DESTINATION_GROUPS.ACTIVE_LISTENERS_ONLY,
      );
      PrivateRoomService.publishToPrivateRoom(
        chatMessageToSend,
        this.myUserId,
        this.props.chatRoomDto.roomId,
        VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CHAT_NO_SAVE,
      );

      //send MessageWasRead to rest server
    }
  };
  doWhenMessagesWasReadSuccessfully = (/* chatMessageDto */) => {
    this.props.updateChatRoomReadersReadMessagesMap(
      this.props.chatRoomDto.roomId,
      this.myUserId,
    );
  };
  compareChatMessageDto = (chatMessageDto1, chatMessageDto2) => {
    var comparison = 0;
    if (
      chatMessageDto1.serverCreationTime > chatMessageDto2.serverCreationTime
    ) {
      comparison = 1;
    } else if (
      chatMessageDto2.serverCreationTime > chatMessageDto1.serverCreationTime
    ) {
      comparison = -1;
    } else if (
      chatMessageDto1.senderCreationTime > chatMessageDto2.senderCreationTime
    ) {
      comparison = 1;
    } else if (
      chatMessageDto2.senderCreationTime > chatMessageDto1.senderCreationTime
    ) {
      comparison = -1;
    }
    return comparison;
  };

  createChatMessageData = (messageContent, subtype, destinationGrp) => {
    let chatRoomId = this.props.chatRoomDto.roomId;

    const senderUserId = this.myUserId;
    const tag = new Date().getTime() + '_' + Math.floor(Math.random() * 1e14);
    return {
      SubType: subtype ? subtype : VIDABOO_CONSTANTS.CHAT_SUBTYPES.TEXT_MESSAGE,
      destinationGroup:
        destinationGrp ??
        VIDABOO_CONSTANTS.PRIVATE_ROOM_DESTINATION_GROUPS
          .ALL_PERMISSIONED_LISTENERS,
      // senderProfileName: this.props.currentUser.profileName,
      senderUserId,
      senderObjectId: this.myParticipantId,
      senderObjectType: this.myParticipantType,
      message: messageContent,
      senderCreationTime: new Date().getTime(),
      targetChatRoomId: chatRoomId,
      roomType: this.props.chatRoomDto.roomType,
      roomOwnerObjectType: this.props.chatRoomDto.ownerObjectType,
      messageTag: chatRoomId + '_' + senderUserId + '_' + tag,
    };
  };

  pushMessageTomessages = (chatMessageObj, pushToFront) => {
    chatMessageObj.sendTimeFormatted = this.formatDate(
      new Date(chatMessageObj.sendTime),
    ); /*.toString('MMM,DD HH:mm');May, 14th 14:24*/
    // console.debug('******3');

    if (!pushToFront) {
      // contScope.chatBoxMessages.push(chatMessageObj);
      const chatBoxMessages = [...this.state.chatBoxMessages, chatMessageObj];
      this.setState({
        chatBoxMessages,
      });
      this.override_scrollBehaviour();
    } else {
      // contScope.chatBoxMessages.unshift(chatMessageObj);
      this.setState({
        chatBoxMessages: [chatMessageObj, ...this.state.chatBoxMessages],
      });
    }
    // console.debug(contScope.chatBoxMessages);
  };

  deleteMessageById = (
    messageId,
    messageTag,
    successCallback,
    failureCallback,
  ) => {
    const deleteMessage = (chatMessageId) => {
      chatService.deleteChatMessageByMessageId(
        chatMessageId,
        () => {
          if (successCallback) successCallback();
          const toastObj = utilsService.getToastObj({
            toastTitle: 'Message deleted successfully',
            toastType: VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.SUCCESS,
          });
          this.context.addToastObj(toastObj);
        },
        () => {
          if (failureCallback) {
            failureCallback(
              `The content hasn’t been fully deleted. Please contact info@consolto.com with these details: roomId: ${this.props.chatRoomDto.roomId}, messageId: ${chatMessageId}`,
            );
          }
        },
      );
    };
    if (!messageId) {
      chatService.getMessageIdByMessageTag(
        messageTag,
        (chatMessageId) => {
          const idx = this.state.chatBoxMessages.findIndex(
            (chatBoxMessage) => chatBoxMessage.messageTag === messageTag,
          );
          if (idx !== -1) {
            deleteMessage(chatMessageId);
          }
        },
        () => {
          if (failureCallback) {
            failureCallback();
          }
        },
      );
    } else deleteMessage(messageId);
  };

  deleteConversation = () => {
    chatService.deleteChatroomByChatroomId(
      this.props.chatRoomDto.roomId,
      () => {},
      () => {
        this.context.setNotificationPopUpData({
          notificationTxt: `The content hasn’t been fully deleted. Please contact info@consolto.com with these details: roomId: ${this.props.chatRoomDto.roomId}`,
          notificationType: VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.WARNING,
          closeBtnTxt: 'Close',
          closeBtnFunc: () => {
            this.context.closeNotificationPopUp();
          },
        });
        this.context.setShowNotificationPopUp(true);
      },
    );
  };

  updatePeerInfoBasedOnLeadCollector = (chatRoomDto) => {
    //we can't have type INFO_MESSAGE in group chat
    if (
      chatRoomDto.roomType === VIDABOO_CONSTANTS.CHAT_ROOM_TYPES.ONE_TO_MANY
    ) {
      return;
    }
    const chatBoxMessages = this.state.chatBoxMessages;
    const chatBoxMessagesLength = chatBoxMessages.length;
    let chatMessageObj = {};
    for (let i = chatBoxMessagesLength - 1; i >= 0; i--) {
      if (
        chatBoxMessages[i].subType ===
          VIDABOO_CONSTANTS.CHAT_SUBTYPES.INFO_MESSAGE &&
        chatBoxMessages[i].fromPeer &&
        chatBoxMessages[i].metaData
      ) {
        chatMessageObj = chatBoxMessages[i];
        break;
      }
    }
    if (
      chatMessageObj.subType === VIDABOO_CONSTANTS.CHAT_SUBTYPES.INFO_MESSAGE &&
      chatMessageObj.fromPeer &&
      chatMessageObj.metaData
    ) {
      const peerInfo = JSON.parse(chatMessageObj.metaData);
      // console.debug('Inside the if fter loop', peerInfo);
      if (peerInfo) {
        //  Call api to update
        let updateChatRoom = false;
        if (chatRoomDto) {
          if (chatRoomDto.chatRoomPeerInfoDto == null) {
            chatRoomDto.chatRoomPeerInfoDto = {};
          }

          if (peerInfo.version !== 'v2') {
            if (
              !chatRoomDto.chatRoomPeerInfoDto.peerEmail &&
              chatRoomDto.chatRoomPeerInfoDto.peerEmail !== peerInfo.email &&
              peerInfo.email
            ) {
              chatRoomDto.chatRoomPeerInfoDto.peerEmail = peerInfo.email;
              updateChatRoom = true;
            }

            if (
              !chatRoomDto.chatRoomPeerInfoDto.peerName &&
              chatRoomDto.chatRoomPeerInfoDto.peerName !==
                peerInfo.senderFirstName &&
              peerInfo.senderFirstName
            ) {
              chatRoomDto.chatRoomPeerInfoDto.peerName =
                peerInfo.senderFirstName;
              updateChatRoom = true;
            }

            if (
              !chatRoomDto.chatRoomPeerInfoDto.peerPhoneNumber &&
              chatRoomDto.chatRoomPeerInfoDto.peerPhoneNumber !==
                peerInfo.phoneNumber &&
              peerInfo.phoneNumber
            ) {
              chatRoomDto.chatRoomPeerInfoDto.peerPhoneNumber =
                peerInfo.phoneNumber;
              updateChatRoom = true;
            }
          } else {
            let peerName = null,
              peerEmail = null,
              peerPhoneNumber = null;
            for (const formField of Object.values(peerInfo.content)) {
              if (formField.field_name === 'email')
                peerEmail = formField.answers;
              if (formField.field_name === 'phone_number')
                peerPhoneNumber = formField.answers;
              if (formField.field_name === 'name') peerName = formField.answers;
            }

            if (
              !chatRoomDto.chatRoomPeerInfoDto.peerEmail &&
              chatRoomDto.chatRoomPeerInfoDto.peerEmail !== peerEmail &&
              peerEmail
            ) {
              chatRoomDto.chatRoomPeerInfoDto.peerEmail = peerEmail;
              updateChatRoom = true;
            }

            if (
              !chatRoomDto.chatRoomPeerInfoDto.peerName &&
              chatRoomDto.chatRoomPeerInfoDto.peerName !== peerName &&
              peerName
            ) {
              chatRoomDto.chatRoomPeerInfoDto.peerName = peerName;
              updateChatRoom = true;
            }

            if (
              !chatRoomDto.chatRoomPeerInfoDto.peerPhoneNumber &&
              chatRoomDto.chatRoomPeerInfoDto.peerPhoneNumber !==
                peerPhoneNumber &&
              peerPhoneNumber
            ) {
              chatRoomDto.chatRoomPeerInfoDto.peerPhoneNumber = peerPhoneNumber;
              updateChatRoom = true;
            }
          }
          this.setState({chatRoomDto}, () => {
            if (updateChatRoom) {
              chatService.updateChatroomByChatroomId(
                chatRoomDto.roomId,
                {chatRoomPeerInfoDto: chatRoomDto.chatRoomPeerInfoDto},
                (/* data */) => {
                  // console.debug("Success", data);
                  this.setState({
                    roomName: chatRoomDto.chatRoomPeerInfoDto.peerName,
                  });
                  this.props.handleChatRoomExtendedInfoChange(
                    chatRoomDto.chatRoomPeerInfoDto,
                    false,
                  );
                },
                () => {
                  console.debug('Failed updating peer name in chat room');
                  this.setState({
                    roomNameWarnTxt: 'Something went wrong!',
                    roomNameWarn: true,
                  });
                },
              );
            }
          });
        }
      }
    }
  };

  setMessageCounter = () => {
    if (this.state.messageCounter > 0 && this.state.needToReset) {
      // contScope.needToReset = false;
      // contScope.messageCounter = 0;
      this.setState({messageCounter: 0});
    }
  };

  formatDate = (date) => {
    var monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    var day = date.getDate();
    var monthIndex = date.getMonth();
    var hour = this.addZero(date.getHours());
    var minute = this.addZero(date.getMinutes());

    return day + ' ' + monthNames[monthIndex] + ' ' + hour + ':' + minute;
  };

  addZero = (value) => {
    if (value < 10) {
      value = '0' + value;
    }
    return value;
  };

  override_peerIsTyping = (wsContent) => {
    this.setState({
      peerIsTyping: true,
      typingParticipantsInfoObj: {
        ...this.state.typingParticipantsInfoObj,
        [wsContent.senderObjectId]: {
          senderObjectId: wsContent.senderObjectId,
          senderObjectType: wsContent.senderObjectType,
        },
      },
    });
    const {scrollHeight, scrollPosition, chatboxHeight} = this.state;
    const movedUp = scrollHeight - chatboxHeight - scrollPosition > 10;
    if (!movedUp) this.scrollToChatTop_Bottom();

    if (this.peerIsTypingTimeoutPromises[wsContent.senderObjectId]) {
      clearTimeout(this.peerIsTypingTimeoutPromises[wsContent.senderObjectId]);
    }

    this.peerIsTypingTimeoutPromises[wsContent.senderObjectId] = setTimeout(
      () => {
        let tempTypingParticipantsInfoObj = {
          ...this.state.typingParticipantsInfoObj,
        };
        delete tempTypingParticipantsInfoObj[wsContent.senderObjectId];
        this.setState(
          {
            typingParticipantsInfoObj: tempTypingParticipantsInfoObj,
          },
          () => {
            if (
              Object.keys(this.state.typingParticipantsInfoObj).length === 0
            ) {
              this.setState({peerIsTyping: false});
            }
          },
        );
      },
      VIDABOO_CONSTANTS.PEER_IS_TYPING_INDICATION_TIME,
    );
  };
  override_peerStoppedTyping = (wsContent) => {
    if (this.peerIsTypingTimeoutPromises[wsContent.senderObjectId]) {
      clearTimeout(this.peerIsTypingTimeoutPromises[wsContent.senderObjectId]);
    }

    let tempTypingParticipantsInfoObj = {
      ...this.state.typingParticipantsInfoObj,
    };
    delete tempTypingParticipantsInfoObj[wsContent.senderObjectId];
    this.setState(
      {
        typingParticipantsInfoObj: tempTypingParticipantsInfoObj,
      },
      () => {
        if (Object.keys(this.state.typingParticipantsInfoObj).length === 0) {
          this.setState({peerIsTyping: false});
        }
      },
    );
  };
  override_doWhenPeerReadChatMessage = (chatMessageTag) => {
    let chatBoxMessages = this.state.chatBoxMessages;
    if (chatBoxMessages) {
      for (var i = 0; i < chatBoxMessages.length; i++) {
        if (
          chatBoxMessages[i].messageTag === chatMessageTag &&
          !chatBoxMessages[i].fromPeer
        ) {
          // this.state.chatBoxMessages[i].messageWasRead = true;
          chatBoxMessages[i].messageWasRead = true;
        }
      }
      this.setState({chatBoxMessages});
    } else {
      // this.props.updateReadMessagesByMessageTag([
      //   ...this.props.readMessagesByMessageTag,
      //   chatMessageTag,
      // ]);
    }
  };

  startMapWithPeer = () => {
    if (this.props.isDemo) return;
    var mapMessageObject = {
      SubType: VIDABOO_CONSTANTS.MAP_SUBTYPES.OPEN_MAP_REQUEST,
      //'clientUserId': contScope.user.userId,
      // senderProfileName: this.props.currentUser.profileName,
      message: {},
    };
    PrivateRoomService.publishToPrivateRoom(
      mapMessageObject,
      this.myUserId,
      this.props.chatRoomDto.roomId,
      VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.MAP,
    );
  };
  startThreedWithPeer = (selected3DFile) => {
    if (this.props.isDemo) return;
    this.setState({threedOn: true});
    var threedMessageObject = {
      SubType: VIDABOO_CONSTANTS.THREED_SUBTYPES.OPEN_THREED_REQUEST,
      //'clientUserId': contScope.user.userId,
      // senderProfileName: this.props.currentUser.profileName,
      message: {selected3DFile},
    };

    PrivateRoomService.publishToPrivateRoom(
      threedMessageObject,
      this.myUserId,
      this.props.chatRoomDto.roomId,
      VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.THREED,
    );
  };
  closeThreed = () => {
    this.setState({threedOn: false});
  };

  handleEmojiBox = () => {
    if (!VIDABOO_CONSTANTS.NATIVE_APP) {
      if (!this.state.displayEmojiBox) {
        document.addEventListener(
          'mousedown',
          this.handleClickForEmojiOnBlur,
          false,
        );
      } else {
        document.removeEventListener(
          'mousedown',
          this.handleClickForEmojiOnBlur,
          false,
        );
      }
    }
    this.setState({displayEmojiBox: !this.state.displayEmojiBox});
  };
  handleClickForEmojiOnBlur = (event) => {
    try {
      //eslint-disable-next-line react/no-find-dom-node
      let node = this.emojiPicker.current;
      if (!node.contains(event.target)) {
        // Handle outside click here
        this.handleEmojiBox();
      }
    } catch (error) {
      return null;
    }
  };
  handleEmoji = (n) => {
    let emoji = String.fromCodePoint(parseInt(n.unified, 16));
    this.setState({
      messageToSend: this.state.messageToSend + emoji,
      // emojiBox: false
    });
  };

  onTextareaChange = (event) => {
    this.setState({messageToSend: event.target.value});
  };

  // openSchedule = (bfiId) => {
  //   // this.props.history.push(`/expertHome/calendar`, {
  //   //   bfiId: bfiId,
  //   // });
  //   this.props.history.push(
  //     `${VIDABOO_CONSTANTS.ROUTES_PATH.SCHEDULING}/${bfiId}`,
  //   );
  // };

  updateChatRoomName = () => {
    let {chatRoomDto} = this.props;
    let requestObj = {};
    if (!chatRoomDto.roomInfoDto) {
      requestObj.roomInfoDto = {};
    } else {
      requestObj.roomInfoDto = chatRoomDto.roomInfoDto;
    }
    requestObj.roomInfoDto.roomName = this.state.roomName;

    chatService.updateChatroomByChatroomId(
      chatRoomDto.roomId,
      requestObj,
      (response) => {
        this.props.updateChatBoxNameInList(
          response.roomInfoDto,
          this.props.chatRoomDto.roomId,
        );
        this.setState(
          {
            roomNameWarn: true,
            roomNameWarnTxt: 'Peer Name updated successfully!',
          },
          () => {
            setTimeout(() => {
              this.setState({roomNameWarnTxt: ''});
            }, 2000);
          },
        );
      },
      () => {
        // console.debug('Failed updating peer name in chat room');
        this.setState({
          roomNameWarnTxt: 'Something went wrong!',
          roomNameWarn: true,
        });
      },
    );
  };

  handleRoomName = (e) => {
    const roomName = e.target.value;
    this.setState({roomName});
  };

  handleRoomNameSubmit = () => {
    let {roomName} = this.state;
    roomName = roomName?.trim();
    this.setState({roomNameWarnTxt: ''});
    if (roomName) {
      this.updateChatRoomName();
      return true;
    } else {
      this.setState({
        roomNameWarn: true,
        roomNameWarnTxt: 'Peer Name cannot be blank!',
      });
      return false;
    }
  };

  handleRoomNameInput = () => {
    let {peerNameFocused} = this.state;
    if (!peerNameFocused) {
      this.setState({peerNameFocused: true}, () =>
        this.peerNameRef.current.focus(),
      );
    } else {
      if (this.handleRoomNameSubmit()) {
        this.setState({peerNameFocused: false}, () =>
          this.peerNameRef.current.blur(),
        );
      } else {
        return;
      }
    }
  };

  isCustomerAvailableForInteraction = () => {
    let isCustomerAvailableForInteraction = true;
    // if (this.context.siteGuestsWidgetStatusObj) {
    if (
      this.props.chatRoomDto.roomType ===
      VIDABOO_CONSTANTS.CHAT_ROOM_TYPES.ONE_TO_MANY
    ) {
      return true;
    }
    if (this.context.siteGuestsWidgetStatusObj[this.siteGuestId]) {
      let siteGuestWidgetStatusObj =
        this.context.siteGuestsWidgetStatusObj[this.siteGuestId];
      if (
        siteGuestWidgetStatusObj.widgetOpenState ===
        VIDABOO_CONSTANTS.ENDPOINT_WIDGET_OPEN_STATES.WIDGET_OPEN
      ) {
        //Widget is not open in the same account
        if (
          siteGuestWidgetStatusObj.otherMountedConnectionContextOwnerId &&
          siteGuestWidgetStatusObj.otherMountedConnectionContextOwnerId !==
            this.props.chatRoomDto.ownerObjectId
        )
          isCustomerAvailableForInteraction = false;
      }
      // }
    }
    return isCustomerAvailableForInteraction;
  };

  addLocalMessageInChatBoxMessages = (localMessageObject) => {
    if (!localMessageObject) return;
    const chatMessages = this.state.chatBoxMessages;
    chatMessages.push(localMessageObject);
    this.setState({chatBoxMessages: chatMessages});
  };

  render() {
    const {chatMarketingParams} = this.state;
    const isInMobile = utilsService.isMobileDevice(); //todomcss : ok
    const isEngagerEnabled =
      this.context.accountDto?.accountAppCtrlDto.isEngagerEnabled &&
      !this.context.accountDto?.usersCtrlMap[this.props.currentUser.userId]
        .disableEngager;

    return (
      <>
        {/* {this.props.chatRoomDto && <ChatBoxPrivateRoomTest parent={this} />} */}
        <ChatBoxRender
          parent={this}
          audioSelected={audioSelected}
          isEngagerEnabled={isEngagerEnabled}
        />
        {!isInMobile && chatMarketingParams && (
          <UpdateMarketingParamsComponent
            action={VIDABOO_CONSTANTS.MARKETING_EVENT_TYPES.USER_USED_CHAT}
          />
        )}
      </>
    );
  }
}

ChatBox.contextType = AppContext;
export default withWidgetContext(
  withExpertHomeContext(withChatbotContext(ChatBox)),
);
